var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRefine = function SvgRefine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-3,.cls-4{fill:none;stroke-linecap:round;stroke-linejoin:round}.cls-3{stroke:#a5aed6}.cls-4{stroke:#c8cee7}"))), /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 0h50v60H10z",
    style: {
      fill: "#e9ecf5",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 10h50v50H0z",
    style: {
      fill: "#e9ecf5",
      isolation: "isolate",
      opacity: 0.5
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.33 53.33A13.33 13.33 0 1 0 25 40a13.33 13.33 0 0 0 13.33 13.33M50.67 50.67 59 59",
    className: "cls-3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 20h25M5 35h13M5 50h13",
    className: "cls-4"
  })))));
};
export default SvgRefine;